import { useEffect, useMemo, useState } from 'react';

import { useFullStory } from '@goshippo/utilities';

import { useAuthentication } from './useAuthentication';
import { usePortalFullStoryUserVars } from './usePortalFullStoryUserVars';
import { useUserAccount } from './useUserAccount';

export const usePortalFullStory = () => {
  const { identify, isInitialized } = useFullStory();
  const [isIdentified, setIsIdentified] = useState(false);
  const { data, status } = useUserAccount();

  const fullStoryIsInitialized = isInitialized();
  const { isImpersonating } = useAuthentication();

  const identifyProps = useMemo(
    () => ({
      displayName: `${data?.firstName} ${data?.lastName}`,
      email: data?.email,
      id: data?.id,
    }),
    [data],
  );

  useEffect(() => {
    if (
      fullStoryIsInitialized &&
      !isIdentified &&
      identifyProps &&
      status === 'success' &&
      !isImpersonating
    ) {
      const { id, ...props } = identifyProps;
      identify(String(id), props);
      setIsIdentified(true);
    }
  }, [identify, fullStoryIsInitialized, isIdentified, identifyProps, status, isImpersonating]);

  usePortalFullStoryUserVars();

  return null;
};
